import { Button } from '@thg-commerce/gravity-elements'
import {
  css,
  mq,
  spacing,
  styled,
  Text,
  zIndex,
  ZIndexLevel,
} from '@thg-commerce/gravity-theme'

export const Container = styled.div`
  position: relative;
`

export const Title = styled.h2<{ alignment?: string }>`
  ${Text('large1', 'alternate')};
  margin: ${spacing(2)} 0 ${spacing(2)};
  text-align: ${(props) => props.alignment || 'center'};
`

export const PlayButton = styled.button`
  position: absolute;
  inset: 0;
  margin: auto;
  width: fit-content;
  height: fit-content;
`

export const VideoContainer = styled.video<{ isVisible: boolean }>`
  ${({ isVisible }) => !isVisible && 'visibility: hidden'};

  &::cue {
    ${Text('medium1', 'default')};
    color: ${(props) => props.theme.colors.palette.greys.white};
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0px;
  }

  height: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.layout.mobile?.height
      ? props.theme.widget.GlobalVideoHeroBannerWidget.layout.mobile?.height
      : props.theme.widget.GlobalVideoHeroBannerWidget.layout.height
      ? `calc(${props.theme.widget.GlobalVideoHeroBannerWidget.layout.height?.widgetHeight} - ${props.theme.widget.GlobalVideoHeroBannerWidget.layout.height?.headerHeight});`
      : 'auto'};
  object-fit: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.layout.mobile?.height ||
    props.theme.widget.GlobalVideoHeroBannerWidget.layout.height
      ? 'cover'
      : 'fill'};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    height: ${(props) =>
      props.theme.widget.GlobalVideoHeroBannerWidget.layout.height
        ? `calc(${props.theme.widget.GlobalVideoHeroBannerWidget.layout.height?.widgetHeight} - ${props.theme.widget.GlobalVideoHeroBannerWidget.layout.height?.headerHeight});`
        : 'auto'};
    object-fit: ${(props) =>
      props.theme.widget.GlobalVideoHeroBannerWidget.layout.height
        ? 'cover'
        : 'fill'};
  }
`

export const PreviewImageContainer = styled.div<{ isVisible: boolean }>`
  position: absolute;
  ${zIndex(ZIndexLevel.Base)}

  ${({ isVisible }) =>
    !isVisible &&
    'visibility: hidden; opacity: 0; transition: visibility 0s 0.5s, opacity 0.5s linear;'}

  width: 100%;
  height: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.layout.height
      ? `calc(${props.theme.widget.GlobalVideoHeroBannerWidget.layout.height?.widgetHeight} - ${props.theme.widget.GlobalVideoHeroBannerWidget.layout.height?.headerHeight});`
      : 'auto'};

  object-fit: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.layout.height
      ? 'cover'
      : 'fill'};
`

export const PreviewImage = styled.div`
  position: relative;
  height: 100%;
`

const ButtonsStyle = css`
  width: 30px;
  height: 30px;
  border-radius: 15px;
`
export const TranscriptTriggerButton = styled(Button)<{
  isVisible: boolean
}>`
  position: absolute;
  ${zIndex(ZIndexLevel.Low)}
  bottom: 32px;
  left: 130px;
  ${ButtonsStyle}
  background-color: #242020;
  &:hover {
    ${ButtonsStyle}
    outline: 2px solid ${(props) => props.theme.colors.palette.greys.white};
  }
  &:focus {
    ${ButtonsStyle}
    outline: 2px solid ${(props) => props.theme.colors.palette.greys.white};
  }
  /* Firefox */
  @supports (-moz-appearance: none) {
    left: auto;
    right: 55px;
    bottom: 45px;
  }
  /* Safari */
  @supports (-webkit-backdrop-filter: none) {
    left: 15px;
    bottom: 45px;
  }
`
export const CaptionTriggerButton = styled(Button)<{
  isVisible: boolean
}>`
  position: absolute;
  ${zIndex(ZIndexLevel.Low)}
  bottom: 32px;
  left: 170px;
  ${ButtonsStyle}
  background-color: #242020;
  &:hover {
    ${ButtonsStyle}
    outline: 2px solid ${(props) => props.theme.colors.palette.greys.white};
  }
  &:focus {
    ${ButtonsStyle}
    outline: 2px solid ${(props) => props.theme.colors.palette.greys.white};
  }
  /* Firefox */
  @supports (-moz-appearance: none) {
    left: auto;
    right: 15px;
    bottom: 45px;
  }
  /* Safari */
  @supports (-webkit-backdrop-filter: none) {
    left: 55px;
    bottom: 45px;
  }
`
export const OverlayContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  top: 0;
`

export const OverlayContent = styled.div<{ ctaOnVideoMobile: boolean }>`
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.overlayContent
      ?.justifyContent
      ? props.theme.widget.GlobalVideoHeroBannerWidget.overlayContent
          ?.justifyContent
      : 'center'};
  align-items: ${(props) => (props.ctaOnVideoMobile ? 'flex-start' : 'center')};
  height: 100%;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    align-items: flex-start;
  }
`

export const OverlayBox = styled.div`
  padding: 12px;
  max-width: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.overlayContent?.width
      ? props.theme.widget.GlobalVideoHeroBannerWidget.overlayContent?.width
      : '100%'};
  text-align: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.overlayContent?.align
      ? props.theme.widget.GlobalVideoHeroBannerWidget.overlayContent?.align
      : 'left'};
`

export const Headline = styled.h2`
  ${Text('xlarge1', 'alternate')};
  color: ${(props) => props.theme.colors.palette.greys.white};
  color: ${(props) => props.theme.colors.palette.greys.white};
`

export const Subtitle = styled.h3`
  ${Text('medium1', 'default')};
  margin: ${spacing(2)} 0 ${spacing(4)};
  color: ${(props) => props.theme.colors.palette.greys.white};
`

export const CTAContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.CTAContainer?.align
      ? props.theme.widget.GlobalVideoHeroBannerWidget.CTAContainer?.align
      : 'flex-start'};
`

export const CTAWrapperDesktop = styled.div<{ ctaOnVideoMobile: boolean }>`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: flex;
  }
  display: ${(props) => (props.ctaOnVideoMobile ? 'none' : 'flex')};
`

export const CTAWrapperMobile = styled.div<{ ctaOnVideoMobile: boolean }>`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: none;
  }
  display: ${(props) => (props.ctaOnVideoMobile ? 'flex' : 'none')};
  padding: ${spacing(2)};
  text-align: center;
`

export const CTAButton1 = styled(Button)`
  width: fit-content;
  border: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.border ??
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.border};
  background-color: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor ??
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor};

  & > a {
    background-color: ${(props) =>
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor ??
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor};
    color: ${(props) =>
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.color ??
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.color};
  }
`

export const CTAButton2 = styled(Button)`
  margin-left: ${spacing(2)};
  border: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.border ??
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.border};
  background-color: ${(props) =>
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor ??
    props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor};

  & > a {
    background-color: ${(props) =>
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor ??
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.backgroundColor};
    color: ${(props) =>
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.color ??
      props.theme.widget.GlobalVideoHeroBannerWidget.cta?.color};
  }
`
